import { Component, OnInit } from '@angular/core';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-extension',
  templateUrl: './extension.component.html',
  styleUrls: ['./extension.component.scss']
})
export class ExtensionComponent implements OnInit {
  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.amplitudeService.logEvent('Panel:Widget:Init');
  }
}
